import React from "react";
import { Modal } from "antd";
import CgIcon from "../common/CgIcon";
import styles from "./saleEntry.module.css";


const DiscardEntryModal = ({
  open,
  onKeepEditing,
  onDiscard,
  onSave,
  saving,
  lineCount = 0,
  patientName,
  working,
  willDiscard = true,
}) => {
  const what =
    lineCount > 0
      ? `${lineCount} ${lineCount === 1 ? "medicine" : "medicines"} on this entry`
      : "This entry";
  const who = patientName ? ` for ${patientName}` : "";

  return (
    <Modal
      className={styles.seDialog}
      open={open}
      centered
      width={460}
      maskClosable={!working && !saving}
      onCancel={working || saving ? undefined : onKeepEditing}
      closeIcon={<span className={styles.iactGlyph}>✕</span>}
      title={
        <div className={styles.seModalT}>
          {willDiscard ? "Discard this sale entry?" : "Leave without saving?"}
        </div>
      }
      footer={
        <div className={styles.seModalF}>
          <div style={{ flex: 1 }} />
          {/*
            * Saving is the answer most people want at this point, so it is the
            * one offered - the entry is written and stays in Pending to be
            * picked up later. Closing the dialog goes back to editing.
            */}
          <button
            type="button"
            className={`${styles.btn} ${styles.btnO}`}
            disabled={working || saving}
            onClick={onSave}
          >
            {saving ? "Saving…" : "Save changes"}
          </button>
          <button
            type="button"
            className={`${styles.btn} ${styles.btnD}`}
            disabled={working || saving}
            onClick={onDiscard}
          >
            {working ? "Leaving…" : willDiscard ? "Discard entry" : "Leave without saving"}
          </button>
        </div>
      }
    >
      <div className={styles.seAsk}>
        <span className={`${styles.seAskIco} ${willDiscard ? "" : styles.seAskIcoCalm}`}>
          <CgIcon name={willDiscard ? "trash" : "info"} size={19} stroke={1.9} />
        </span>
        <div>
          <div className={styles.seAskT}>
            {willDiscard
              ? "Nothing here has been saved yet"
              : "These changes have not been saved"}
          </div>
          <div className={styles.seAskS}>
            {willDiscard ? (
              <>
                {what}
                {who} will be lost. Saving writes the order and leaves it in Pending to
                be finished later; no bill is raised either way.
              </>
            ) : (
              /* The order itself survives - it is the editing done on this
                 screen since it was opened that does not. */
              <>
                The changes to {what.replace(/^This entry$/, "this entry")}
                {who} will be lost unless you save them. Saving keeps the order in
                Pending with the changes on it; no bill is raised either way.
              </>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DiscardEntryModal;
